<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Duplicar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ aulaDuplicada.tipo_de_aula }}
                    </p>
                  </v-col>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Bimestre</e-label>
                    <ValidationProvider name="Bimestre" rules="required" v-slot="{ errors }">
                      <v-select
                        :disabled="aulaDuplicada.tipo_de_aula ? false : true"
                        :items="bimestres"
                        :return-object="false"
                        @change="($event) => atualizarData($event)"
                        v-model="aulaDuplicada.bimestre_id"
                        :item-text="
                          (item) =>
                            item.status === 0
                              ? item.descricao
                              : `${item.descricao} (Bimestre Bloqueado)`
                        "
                        :item-value="(item) => item.id"
                        :item-disabled="(item) => item.status === 1"
                        label="Selecione um bimestre"
                        dense
                        solo
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col class="pt-0 pb-0" :cols="12" :sm="12">
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Selecione uma data</e-label>
                        <ValidationProvider
                          name="Data da aula"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            dense
                            solo
                            v-model="data"
                            label="Data"
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                            autocomplete="off"
                            readonly
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="dataAulaDuplicada"
                        scrollable
                        :min="bimestreSelecionado?.data_inicial"
                        :max="bimestreSelecionado?.data_final"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col class="pt-0 pb-0" v-if="!aulaRemota" cols="12" sm="12">
                    <ValidationProvider name="Horário" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <v-select
                        :items="horariosList ? horariosList : horarios"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        solo
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <div>
                  <e-conteudo-aula-infantil v-if="aulaInfantil" :aula="aulaDuplicada" />
                  <e-conteudo-aula-regular v-else :aula="aulaDuplicada" />
                </div>

                <v-divider class="my-6"></v-divider>

                <!-- Verificador de conflitos -->
                <e-verificador-conflitos-aula
                  v-if="!aulaRemota"
                  :data="dataAulaDuplicada"
                  :horario-id="horarioSelecionado?.id"
                  :turma-id="gestaoDeAulas?.turma_id"
                  :aula-id="null"
                  :e_aula_infantil="!!aulaDuplicada.e_aula_infantil"
                  @conflitos-encontrados="temConflitos = $event"
                />

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperadosFiltrados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false), limparCampos()"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="faltaPreencher || !totalmentePreenchido || temConflitos"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
            <v-row v-if="validacao">
              <v-col cols="12" class="mt-4">
                <v-alert type="warning" border="left">
                  Por favor, preencha todos os campos!
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    >
    </e-modal-confirm>
    <!-- <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :horarios="horarios"
      :horariosList="horariosList"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula> -->
  </v-row>
</template>

<script>
import EConteudoAulaInfantil from "./EConteudoAulaInfantil.vue";
import EConteudoAulaRegular from "./EConteudoAulaRegular.vue";

export default {
  components: { EConteudoAulaInfantil, EConteudoAulaRegular },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: false,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
    horariosList: {
      type: Array,
      require: false,
    },
  },
  data() {
    return {
      bimestres: [],
      bimestreSelecionado: null,
      data: null,
      date: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      validacao: false,
      itemsEsperados: [
        { label: "Bimestre", value: "aulaDuplicada.bimestre_id" },
        { label: "Data", value: "data" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      temConflitos: false,
    };
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperadosFiltrados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  computed: {
    faltaPreencher() {
      return !this.data || !this.horarioSelecionado || !this.horarioSelecionado.id;
    },
    aulaInfantil() {
      return this.aulaDuplicada.e_aula_infantil === 1;
    },
    aulaRemota() {
      return this.aulaDuplicada?.tipo_de_aula === "Aula Remota";
    },
    itemsEsperadosFiltrados() {
      if (this.aulaRemota) {
        return this.itemsEsperados.filter((item) => item.value !== "horarioSelecionado");
      }
      return this.itemsEsperados;
    },
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
        this.aulaDuplicada.bimestre_id = null;
        this.loadBimestresDisponiveis();
      },
    },
    dataAulaDuplicada(value) {
      if (!value) return;
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
    },
  },
  methods: {
    atualizarData(value) {
      this.bimestreSelecionado = this.bimestres.find((item) => item.id === value);
    },
    async loadBimestresDisponiveis() {
      const data = await this.$services.usuariosService.getBimestresDisponiveis();
      this.bimestres = data;
      this.bimestreSelecionado = this.bimestres.find(
        (item) => item.id === this.aulaDuplicada.bimestre_id
      );
    },
    enableSubmit() {
      if (!this.horarioSelecionado.id || !this.data) {
        this.validacao = true;
      } else {
        this.validacao = false;
        this.confirmDialog = !this.confirmDialog;
        this.aulaDuplicada.data = this.dataAulaDuplicada;
      }
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.horarios = [];
        if (this.horarioSelecionado) {
          this.aulaDuplicada.horarios.push(this.horarioSelecionado.id);
        }
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.gestaoDeAulas.disciplina_id;
        this.aulaDuplicada.turma_id = this.gestaoDeAulas.turma_id;
        this.aulaDuplicada.instrutor_id = this.gestaoDeAulas.instrutor_id;
        await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        this.$toast.success("Aula duplicada com sucesso!");
        // this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    limparCampos() {
      this.aulaDuplicada.bimestre_id = null;
      this.data = null;
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = null;
      this.totalmentePreenchido = false;
      this.temConflitos = false;
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
  },
};
</script>
